// =============================================================================
// CẤU HÌNH ĐỘNG KVC 2026 (Giải thưởng Khuê Văn Các) — LINK TÀI LIỆU, BẢNG ĐIỂM,
// CÁC MẢNG LỰA CHỌN DÙNG TRONG FORM ĐĂNG KÝ / CHẤM ĐIỂM / XEM HỒ SƠ.
// Gom về một chỗ để dễ chỉnh sửa mà không phải lục trong code.
// =============================================================================

export const KVC2026_LINKS = {
  // Mẫu công văn cơ quan, đơn vị đề cử năm 2026
  mauCongVanDeCu:
    "https://docs.google.com/document/d/1yRlaaFU7oLmqKfd_ifGEibwucb270UMCZOBqHH8NIqo/edit?usp=sharing",

  // Mẫu "Kế hoạch hành động và cam kết của ứng viên đóng góp sau Giải thưởng"
  mauCamKet:
    "https://docs.google.com/document/d/134ar8Yn7ZgMOCR_CtXq4IROhXU3vjU5OQUJQkQjP21w/edit?usp=sharing",

  // Bảng điểm chấm các thành tích (tham chiếu cho hội đồng / BTC)
  bangDiemChamThanhTich:
    "https://drive.google.com/file/d/1BfBLtADVTv0R1ewGX3vENMrskttdgAlp/view?usp=sharing",
};

// A. CÔNG TRÌNH TIÊU BIỂU — 04 tiêu chí chấm điểm (tối đa 50 điểm).
//   work1: 10đ, work2: 10đ, work3: 15đ, work4: 15đ.
export const KVC2026_TYPICAL_WORK_FIELDS = [
  {
    key: "work1",
    maxPoint: 10,
    label:
      "Tên công trình, mục tiêu, phương pháp và tính mới trong nghiên cứu",
    hint:
      "Ý tưởng mới, tính sáng tạo, tính đột phá so với các nghiên cứu trước.",
  },
  {
    key: "work2",
    maxPoint: 10,
    label:
      "Vai trò của ứng viên (tác giả độc lập/chính) và mức độ đóng góp",
    hint:
      "Tác giả độc lập, chủ biên, tác giả thứ nhất hoặc tác giả liên hệ; mức độ đóng góp thực chất đối với kết quả nghiên cứu (nếu công trình có nhiều hơn một tác giả).",
  },
  {
    key: "work3",
    maxPoint: 15,
    label:
      "Giá trị khoa học: uy tín tạp chí/NXB, chỉ số ảnh hưởng (Impact Factor), số trích dẫn",
    hint:
      "Uy tín tạp chí/nhà xuất bản; yếu tố tác động (Impact Factor); số lượt trích dẫn (citation index); mức độ lan tỏa trong giới chuyên môn.",
  },
  {
    key: "work4",
    maxPoint: 15,
    label:
      "Giá trị thực tiễn: đóng góp phát triển khoa học, ứng dụng thực tiễn, ảnh hưởng cộng đồng và xã hội (có xác nhận của cơ quan/tổ chức sử dụng nếu đã ứng dụng)",
    hint:
      "Khả năng ứng dụng hiệu quả trong thực tiễn; ảnh hưởng đến phát triển khoa học, kinh tế – xã hội và có xác nhận của cơ quan/tổ chức sử dụng (nếu đã ứng dụng).",
  },
];

// Tổng hợp nội dung 4 mục công trình tiêu biểu thành HTML để hiển thị/xuất file
// (lưu vào field `summary`). Nhận object {work1..work4}.
export const composeTypicalWorkHtml = (content) => {
  if (!content) return "";
  const hasText = (v) =>
    (v || "")
      .replace(/<[^>]*>/g, "")
      .replace(/&nbsp;/g, " ")
      .trim().length > 0;
  return KVC2026_TYPICAL_WORK_FIELDS.filter((f) => hasText(content[f.key]))
    .map((f) => `<p><b>${f.label}:</b> ${content[f.key]}</p>`)
    .join("");
};

// C.1.1 — 8 hình thức khen thưởng cấp Nhà nước.
export const KVC2026_STATE_REWARD_OPTIONS = [
  { key: "huan_chuong", title: "Huân chương", value: "huan_chuong" },
  { key: "huy_chuong", title: "Huy chương", value: "huy_chuong" },
  {
    key: "danh_hieu_vinh_du",
    title: "Danh hiệu vinh dự Nhà nước",
    value: "danh_hieu_vinh_du",
  },
  {
    key: "giai_thuong_hcm",
    title: "Giải thưởng Hồ Chí Minh",
    value: "giai_thuong_hcm",
  },
  {
    key: "giai_thuong_nn",
    title: "Giải thưởng Nhà nước",
    value: "giai_thuong_nn",
  },
  {
    key: "co_thi_dua_cp",
    title: "Cờ thi đua của Chính phủ",
    value: "co_thi_dua_cp",
  },
  {
    key: "bang_khen_ttg",
    title: "Bằng khen của Thủ tướng Chính phủ",
    value: "bang_khen_ttg",
  },
  {
    key: "cstd_toan_quoc",
    title: "Chiến sĩ thi đua toàn quốc",
    value: "cstd_toan_quoc",
  },
];

// D. CAM KẾT CỦA ỨNG VIÊN — 5 nội dung kế hoạch hành động (tối thiểu 03 năm).
export const KVC2026_COMMITMENT_FIELDS = [
  {
    key: "plan1",
    label: "1) Các hoạt động cụ thể đồng hành cùng Giải thưởng:",
  },
  {
    key: "plan2",
    label:
      "2) Các hoạt động cụ thể hỗ trợ học sinh, sinh viên, nhà nghiên cứu trẻ trong nghiên cứu khoa học:",
  },
  {
    key: "plan3",
    label:
      "3) Các hoạt động cụ thể chia sẻ tri thức, truyền cảm hứng và đóng góp cho cộng đồng:",
  },
  {
    key: "plan4",
    label:
      "4) Tham gia tích cực các hoạt động do Trung ương Đoàn, Trung tâm Phát triển KHCN và tài năng trẻ tổ chức:",
  },
  { key: "plan5", label: "5) Đề xuất, hiến kế các nội dung, mô hình cụ thể:" },
];
